/**
 * Super class with a set of useful methods.
 */
export default class Base {

	/**
	 * Gets an element's width including its margins.
	 * @param  {HTMLElement} el Element
	 * @return {Number}
	 */
	outerWidth(el) {
		let style = window.getComputedStyle(el);
		return parseFloat(style.width) + parseFloat(style.marginRight) + parseFloat(style.marginLeft);
	}

	/**
	 * Gets an element's height including its margins.
	 * @param  {HTMLElement} el Element
	 * @return {Number}
	 */
	outerHeight(el) {
		let style = window.getComputedStyle(el);
		return parseFloat(style.height) + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
	}

	/**
	 * Finds an element's parent by its class name.
	 * @param  {HTMLElement} el          Child element
	 * @param  {String}      parentClass Parent element's class name
	 */
	findParent(el, parentClass) {
 		let parent = el.parentElement;
 		while (!parent.classList.contains(parentClass) && parent.nodeName != 'HTML') {
 			parent = parent.parentElement;
 		}
 		return (parent.nodeName != 'HTML') ? parent : false;
 	}

	/**
	 * Checks if an element is in the current browser viewport.
	 * @param  {el} el HTML element that needs to be checked
	 * @return {bool}
	 */
	viewport(el, offset) {
		if (typeof offset === 'undefined') offset = 0;

		let rect = el.getBoundingClientRect();

		if (rect.top < window.innerHeight - offset && rect.bottom > 0 + offset) {
			return true;
		} else {
			return false;
		}
	}

}
